import { Component, Input, OnInit } from '@angular/core';
import { Cloudinary, XmStore, XmStoreUtil } from 'core/services';
import { CmsCore } from 'store/cms/models';
import { Subscription } from 'rxjs';
import { FCC_BROADBAND_FOOTER } from 'my-account/constants';
import { Account, User } from 'store/user/models';

@Component({
    selector: 'xm-fcc-broadband-label',
    styleUrls: ['./fcc-broadband-label.scss'],
    templateUrl: './fcc-broadband-label.html',
    standalone: false
})
export class XmFccBroadBandLabelComponent implements OnInit {
    @Input() public labelDetails: LabelDetails;

    public expanded: boolean = false;
    public imageOptions: MediaImageOptions;
    public footerText: string = FCC_BROADBAND_FOOTER.READ_MORE;
    public geoCode: string;
    public state: string;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor( xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (result: CmsCore) => {
            this.imageOptions = { mobile: Cloudinary.generateMediaFromCms(result.nav.caretIcon) };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peekChild<Account, User>('account', Account, User), (account: Account) => {
            this.geoCode = account?.geoCode;
            this.state = account?.serviceAddress?.state;
        }));
    }

    public toggleSection(): void {
        this.expanded = !this.expanded;
        this.footerText = this.expanded ? FCC_BROADBAND_FOOTER.READ_LESS : FCC_BROADBAND_FOOTER.READ_MORE;
    }
}
